<template>
	<section class="social-wrapper">
		<div class="container">
			<div class="page-top">
				<div class="title">全方位解决客户与研发痛点</div>
				<el-input class="input-key" placeholder="请输入关键字搜索" v-model="keyword">
				    <i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
			<el-tabs class="tab-container" v-model="activeName" >
			    <el-tab-pane label="行业团队" name="expert" v-if="activeName == 'expert'"></el-tab-pane>
			    <el-tab-pane label="任务展示" name="demand" v-else></el-tab-pane>
			</el-tabs>
			<div class="list-container">
				<router-view></router-view>
			</div>
			<div class="sidebar">
				<div class="side-item">
					<div class="release-title"><el-image :src="require('@/assets/lihua.png')" fit="contain"></el-image> 欢迎来到欢软众包 !</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>海量选择 一呼百应</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>智能发布 快速响应</div>
					<div class="desc"><i class="iconfont icon-duigou"></i>全程监管 安全合规</div>
					<el-button class="release-btn" type="warning" size="medium">发布需求</el-button>
				</div>
				
				<div class="side-item">
					<div class="title">公众号</div>
					<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
					<div class="tips">关注微信公众号，订阅每周资讯</div>
				</div>
				<div class="active-image">
					<el-image :src="require('@/assets/activity-image.png')" fit="contain">
						<div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</div>
					</el-image>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { getType,getList } from '@/api/social/index'
export default {
    data() {
      return {
        activeName: '',
		keyword: '',
		total: 0,
		page: 1,
		list:[],
      };
    },
    methods: {
      
    },
	mounted(){
		if(this.$route.path.indexOf('expert') !== -1){
			this.activeName = 'expert'
		}else if(this.$route.path.indexOf('demand') !== -1){
			this.activeName = 'demand'
		}
	}
}
</script>

<style lang="scss" scoped>
.social-wrapper{
	background-image: url('../../assets/shequ-bg.png');
	background-repeat: no-repeat;
	background-size: 100% 300px;
	margin: 0;
	padding-top: 80px;
	.container{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		.page-top{
			padding: 30px 0 50px;
			position: relative;
			.active-image{
				position: absolute;
				top: 25px;
				right: 0;
				.el-image{
					width: 270px;
				}
			}
			.title{
				font-size: 32px;
				font-weight: 800;
				margin: 20px 0;
			}
			.input-key{
				border-radius: 40px;
				max-width: 420px;
				/deep/.el-input__prefix{
					left: 12px;
					font-size: 18px;
				}
				/deep/.el-input__inner{
					border-radius: 20px;
					padding-left: 40px;
					border: none;
				}
			}
		}
		.tab-container{
			margin: 50px auto 20px;
			/deep/.el-tabs__nav-wrap::after{
				// background-color: unset;
				height: 1px;
			}
			/deep/.el-tabs__active-bar{
				width: 25px !important;
				margin-left: 25px;
				background-color: #333333;
			}
			/deep/.el-tabs__item{
				font-size: 18px;
				font-weight: 800px;
				&.is-active{
					color: #333333;
				}
				&:hover{
					color: #333333;
				}
			}
		}
		/deep/.el-pager li.active {
		    color: #FF842E;
		    cursor: default;
		}
		/deep/.el-pager li:hover {
		    color: #FF842E;
		}
		/deep/.el-pagination button:hover{
			color: #FF842E;
		}
		/deep/.el-image__error{
			height: 100px;
		}
		/deep/.el-pagination{
			text-align: center;
		}
		.list-item{
			cursor: pointer;
			margin-top: 10px;
			.item-content{
				display: inline-block;
				width: calc(100% - 180px);
				vertical-align: top;
				.title,.abstrc{
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.title{
					font-size: 18px;
					font-weight: 800;
					color: #292929;
					margin: 10px 0;
					&:hover{
						opacity: .82;
					}
				}
				.abstrc{
					font-size: 16px;
					color: #596372;
				}
			}
			
		}
		.image-wrapper{
			display: inline-block;
			margin-left: 30px;
			.el-image{
				width: 150px;
				border-radius: 5px;
			}
		}
		.list-container{
			width: calc(100% - 300px);
			display: inline-block;
			vertical-align: top;
		}
		.sidebar{
			display: inline-block;
			vertical-align: top;
			.active-image{
				.el-image{
					width: 270px;
					margin: 0 0 30px 30px;
					
				}
			}
			.side-item{
				width: 270px;
				box-sizing: border-box;
				padding: 24px;
				margin: 0 0 30px 30px;
				border-radius: 15px;
				box-shadow: 0 0 15px rgba(0,0,0, .05);
				background-color: #fff;
				.release-title{
					font-size: 20px;
					font-weight: 800;
					margin-bottom: 10px;
					.el-image{
						width: 24px;
						margin-right: 5px;
						vertical-align: text-top;
					}
				}
				.desc{
					color: #596372;
					font-size: 15px;
					.icon-duigou{
						color: #FF842E;
						font-size: 12px;
						margin-right: 16px;
					}
				}
				.release-btn{
					background-color: #FF842E;
					width: 100%;
					border-radius: 20px;
					margin-top: 20px;
				}
				
				.title{
					font-size: 18px;
					font-weight: 800;
					color: #2B2B2B;
					margin-bottom: 15px;
				}
				.qrcode{
					margin: 20px auto;
					width: 80%;
					display: block;
				}
				.tips{
					font-size: 14px;
					color: #525254;
					text-align: center;
				}
				
				
			}
		}
	}
}
</style>